<div
    class="tw-bg-white tw-rounded-[10px] md:tw-p-[19px] tw-p-0 tw-pb-[19px] tw-flex tw-flex-col tw-items-center tw-justify-between tw-text-center md:tw-border md:tw-border-[#7B757580] tw-border-0 tw-h-full tw-whitespace-normal tw-break-words"
>
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-5">
        <ng-container *ngIf="image">
            <div
                class="md:tw-w-[253px] tw-w-full tw-p-[14px] tw-h-[168px] tw-bg-[#EDEDED] md:tw-bg-white md:tw-bg-none md:tw-border-2 md:tw-border-[#0000001A] md:tw-p-[25px] tw-flex tw-items-center tw-justify-center tw-rounded-t-[10px] tw-overflow-hidden tw-border-0"
            >
                <img
                    [src]="image"
                    [alt]="title"
                    class="tw-w-full tw-h-full tw-object-contain tw-rounded-md"
                />
            </div>
        </ng-container>
        <div
            class="tw-flex tw-flex-col tw-gap-[14px] tw-items-center tw-justify-center w-full tw-px-[19px] md:tw-px-0 tw-flex-grow"
        >
            <span
                class="tw-text-[#024B3F] tw-font-bold tw-text-[16px] tw-h-[38.4px]"
            >
                {{ title }}
            </span>
            <div class="tw-flex tw-flex-col tw-gap-[10px]">
                <span
                    class="tw-font-semibold tw-text-black tw-text-[14px] tw-h-[34px]"
                >
                    {{ subtitle }}
                </span>
                <span
                    class="tw-text-[#7B7575] lg:tw-text-[14px] md:tw-text-[14px] tw-font-medium default-html"
                    [innerHTML]="description"
                ></span>
            </div>
        </div>
    </div>

    <div class="tw-w-full tw-flex tw-flex-col tw-gap-5 tw-items-center">
        <hr class="tw-w-full tw-border-2 tw-border-[#6D7A871A]" />
        <button
            [attr.ga-event-id]="ga?.id"
            [attr.ga-event-category]="ga?.category"
            [attr.ga-event-label]="ga?.label"
            ga-track="track"
            class="tw-px-[32px] tw-py-[12px] tw-bg-[#024B3F] tw-rounded-[32px] tw-cursor-pointer"
            (click)="onButtonClick(); $event.stopPropagation()"
            type="button"
        >
            <span
                class="tw-text-white tw-text-[16px] tw-font-semibold tw-pointer-events-none"
                >{{ buttonText }}</span
            >
        </button>
    </div>
</div>
